import React, { useEffect, useState } from 'react';
import { Checkbox, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { ALM_KIND_SET } from '../../../../function/AlmKindSetModel';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import { TableBaseStyle } from './AlmKindRegistStyle';

type AlmKindRegistGridBodyProps = {
  almKindSetItem: ALM_KIND_SET;
  updateItem: (item: ALM_KIND_SET) => void;
  mclcTypList: ComboBoxItemType[];
};

const AlmKindRegistGridBody: React.FC<AlmKindRegistGridBodyProps> = (props: AlmKindRegistGridBodyProps) => {
  const classes = TableBaseStyle();
  const [itemName, setItemName] = useState<string>(props.almKindSetItem.TYP_NAME);
  const [message, setMessage] = useState<string>(props.almKindSetItem.GUIDE_MSG);
  const [messageL, setMessageL] = useState<string>(props.almKindSetItem.GUIDE_MSGL);
  const [mclcTypId, setMclcTypeId] = useState<number>(props.almKindSetItem.MCLC_TYP_ID);

  useEffect(() => {}, []);

  return (
    <TableRow key={props.almKindSetItem.TYP_NO}>
      {/* No */}
      <TableCell className={classes.tableItem} width={'40px'}>
        {props.almKindSetItem.TYP_NO}
      </TableCell>
      {/* 演算種別 */}
      <TableCell className={classes.tableItem} width={'240px'}>
        <ItemComboBox
          itemList={props.mclcTypList}
          label=""
          value={mclcTypId}
          onChangeEvent={(e) => {
            if (typeof e.target.value == 'string') {
              setMclcTypeId(parseInt(e.target.value));
              props.almKindSetItem.MCLC_TYP_ID = parseInt(e.target.value);

              if (parseInt(e.target.value) === 0) {
                props.almKindSetItem.TYP_NAME = '';
                props.almKindSetItem.GUIDE_MSG = '';
                props.almKindSetItem.GUIDE_MSGL = '';
                setMessage('');
                setMessageL('');
                setItemName('');
              }
              props.updateItem(props.almKindSetItem);
            }
          }}
        />
      </TableCell>
      {/* 異常内容 */}
      <TableCell className={classes.tableItem} width={'120px'}>
        <input
          type="text"
          className={classes.textField}
          value={itemName}
          maxLength={16}
          onChange={(e) => {
            setItemName(e.target.value);
            props.almKindSetItem.TYP_NAME = e.target.value;
            props.updateItem(props.almKindSetItem);
          }}
        />
      </TableCell>
      {/* 重故障メッセージ */}
      <TableCell className={classes.tableItemL} width={'240px'}>
        <input
          type="text"
          className={classes.textField}
          value={message}
          maxLength={32}
          onChange={(e) => {
            setMessage(e.target.value);
            props.almKindSetItem.GUIDE_MSG = e.target.value;
            props.updateItem(props.almKindSetItem);
          }}
        />
      </TableCell>
      {/* 軽故障メッセージ */}
      <TableCell className={classes.tableItemL} width={'240px'}>
        <input
          type="text"
          className={classes.textField}
          value={messageL}
          maxLength={32}
          onChange={(e) => {
            setMessageL(e.target.value);
            props.almKindSetItem.GUIDE_MSGL = e.target.value;
            props.updateItem(props.almKindSetItem);
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default AlmKindRegistGridBody;
